import ReviewsStoreBase from "@apps/reviews/stores/ReviewsStoreBase";
import { StoreConfig } from "@datorama/akita";

@StoreConfig({ name: "ProductReviewsMiniSliderWidgetReviewsStore" })
class ProductReviewsMiniSliderWidgetReviewsStore extends ReviewsStoreBase {}

export default ProductReviewsMiniSliderWidgetReviewsStore;
